import { Server } from '#enums';

export const PSSRStatusCSSClasses: Record<number, string> = {
  [Server.PSSRStatus.Draft]: 'label-draft',
  [Server.PSSRStatus.Initiated]: 'label-initiated',
  [Server.PSSRStatus.InProgress]: 'label-progress',
  [Server.PSSRStatus.Completed]: 'label-completed',
  [Server.PSSRStatus.PendingApproval]: 'label-pending',
  [Server.PSSRStatus.Approved]: 'label-approved',
  [Server.PSSRStatus.Closed]: 'label-closed',
};
